import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ExternalLinkModal from './ExternalLinkModal';
import { toneForApp } from '../lib/connectedApps';
import type { ConnectedApp } from '../lib/connectedApps';
import { fetchConnectedApps } from '../api/developers';

/**
 * トップページの「連携アプリケーション」セクション。
 * GET /connected-apps（開発者ポータルの掲載申請で承認済み(approved)のもののみ）を
 * マウント時に一度だけ取得する。取得中・エラー・0件はここで何も描画しない
 * （AnimationCarousel.tsx と同様、呼び出し側で条件分岐せずに済むようにする）。
 * エラーはコンソールに warn するのみで、UI には出さない。
 */
export default function ConnectedAppsSection() {
  const [apps, setApps] = useState<ConnectedApp[]>([]);
  const [selected, setSelected] = useState<ConnectedApp | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchConnectedApps()
      .then((items) => {
        if (!cancelled) setApps(items);
      })
      .catch((e) => console.warn('連携アプリ一覧の取得に失敗しました', e));
    return () => {
      cancelled = true;
    };
  }, []);

  if (apps.length === 0) return null;

  return (
    <section className="carousel-section connected-apps">
      <div className="carousel-section__head">
        <h2>掲載アニメーションが使えるアプリ</h2>
        <Link to="/developers/portal" className="more">アプリを登録する</Link>
      </div>
      <div className="connected-apps__row">
        {apps.map((app) => (
          <button type="button" className="app-tile" key={app.id} onClick={() => setSelected(app)}>
            <span className={`app-icon app-icon--lg ${!app.iconUrl ? `app-icon--tone${toneForApp(app)}` : ''}`}>
              {app.iconUrl ? <img src={app.iconUrl} alt="" /> : app.name.charAt(0)}
            </span>
            <span className="app-tile__name">
              {app.name}
              <svg width="11" height="11" viewBox="0 0 12 11" fill="none" aria-hidden="true">
                <path d="M4 2h6v6M10 2 3.5 8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </button>
        ))}
      </div>
      <ExternalLinkModal
        open={selected !== null}
        app={selected}
        onCancel={() => setSelected(null)}
        onConfirm={() => {
          window.open(selected!.url, '_blank', 'noopener,noreferrer');
          setSelected(null);
        }}
      />
    </section>
  );
}
